export default "__VITE_ASSET__D$vbjDx1__"